import { useNavigate } from 'react-router-dom'

import PropTypes from 'prop-types'
import { date } from 'utilities'
import string from 'utilities/string'
import rightarrow from '../assets/arrow-right.svg'

const ProgramCard = ({ cover_image_link, title, description, created_at, program_date, isAdmin, id, apply_link, isPastProgram }) => {
  const navigate = useNavigate()

  const viewProgram = () => {
    navigate(isAdmin ? `/admin/programs/${id}` : `/programs/${id}`)
  }

  const { plainText: plainDescriptionText } = string.extractTextFromMarkdown(description)

  const displayDate = program_date ? date.formatDate(program_date) : date.formatDate(created_at)

  return (
    <div className='flex flex-col items-left cursor-pointer' onClick={viewProgram}>
      <img src={cover_image_link} alt='Job' className='h-[280px] w-full rounded-md mb-[15px] object-cover border border-solid border-[#eee]' />

      <div>
        <p className='text-[#6C757D] text-xs font-normal mb-[15px]'>{displayDate}</p>
        <h2 className='text-lg font-medium text-[#495057] leading-6 mb-[15px] line-clamp-1'>{title}</h2>

        <p className='text-[#6C757D] font-normal mb-[15px] text-xs leading-5 h-16 w-full line-clamp-3'>{plainDescriptionText}</p>

        {isAdmin ? null : !isPastProgram && apply_link?.trim() ? (
          <a
            href={apply_link}
            target='_blank'
            rel='noreferrer'
            onClick={(e) => e.stopPropagation()}
            className='flex items-center font-medium text-sm text-[#BF5540] hover:text-[#c78379] transition-colors duration-300 apply-link w-max'
          >
            Apply Now <img src={rightarrow} alt='Arrow' className='w-5 ml-2' />
          </a>
        ) : (
          <span className='inline-flex items-center font-medium text-sm text-[#6C757D]'>View details</span>
        )}
      </div>
    </div>
  )
}

ProgramCard.propTypes = {
  cover_image_link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  apply_link: PropTypes.string,
  created_at: PropTypes.string.isRequired,
  program_date: PropTypes.string,
  isAdmin: PropTypes.bool,
  id: PropTypes.string,
  isPastProgram: PropTypes.bool,
}

export default ProgramCard
